(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bon-loyalty-custom"] && !Shopify.designMode) return;
  try {
    (() => {
    const radioSelector = 'input.sss-selling-plan-radio';
    const rewardsSelector = 'a[data-bon-trigger], a[href="#bon-loyalty-widget-toggle"]';

    function labelRadio(input) {
      const details = input.closest('.purchase-option-details');
      const label = details && details.querySelector('label');
      const text = label && label.textContent.replace(/\s+/g, ' ').trim();
      if (text && input.getAttribute('aria-label') !== text) {
        input.setAttribute('aria-label', text);
      }
    }

    function labelRewards(control) {
      if (control.getAttribute('role') !== 'button') control.setAttribute('role', 'button');
      if (control.getAttribute('tabindex') !== '0') control.setAttribute('tabindex', '0');
    }

    function enhance(root) {
      if (!(root instanceof Element)) return;
      if (root.matches(radioSelector)) labelRadio(root);
      if (root.matches(rewardsSelector)) labelRewards(root);
      root.querySelectorAll(radioSelector).forEach(labelRadio);
      root.querySelectorAll(rewardsSelector).forEach(labelRewards);
      const details = root.closest('.purchase-option-details');
      if (details) details.querySelectorAll(radioSelector).forEach(labelRadio);
    }

    function start() {
      enhance(document.body);
      const observer = new MutationObserver((records) => {
        for (const record of records) {
          if (record.type === 'attributes') {
            enhance(record.target);
          } else {
            record.addedNodes.forEach(enhance);
            if (record.target instanceof Element && record.target.closest('.purchase-option-details')) {
              enhance(record.target);
            }
          }
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-bon-trigger'],
      });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        if (event.repeat || !(event.target instanceof Element)) return;
        const control = event.target.closest(rewardsSelector);
        if (!control || control.getAttribute('role') !== 'button') return;
        event.preventDefault();
        control.click();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
